/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
const config = {
  sentry: {
    dsn: process.env.REACT_APP_SENTRY_DSN,
  },
};

export default config;
